import axios from "axios";
import { BASE_SERVER_URL } from "../../defaults";

import { setAlert } from "../alert.js";
import { GET_HEAD1S, GET_HEAD1, HEAD1_ERROR, DELETE_HEAD1 } from "../types";

// Create or update user
export const createHead1 = (
  formData,
  history,
  edit = false,
  id = null
) => async dispatch => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    const res = await axios.post(
      "/api/content/addhead1",
      { ...formData, id },
      config
    );

    dispatch({
      type: GET_HEAD1,
      payload: res.data
    });

    dispatch(
      setAlert(
        edit
          ? "The Topic details have been updated successfully"
          : "Topic was created successfully",
        "success"
      )
    );

    history.push("/head1-page");
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: HEAD1_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get posts
export const getHead1s = () => async dispatch => {
  try {
    const res = await axios.get(BASE_SERVER_URL + "/api/content/head1");

    dispatch({
      type: GET_HEAD1S,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: HEAD1_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get current user
export const getCurrentHead1 = id => async dispatch => {
  try {
    const res = await axios.get(`/api/content/head1/${id}`);

    dispatch({
      type: GET_HEAD1,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: HEAD1_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Delete post
export const deleteHead1 = id => async dispatch => {
  if (window.confirm("Are you sure? This can NOT be undone!")) {
    try {
      await axios.delete(`/api/content/head1/${id}`);
      dispatch({
        type: DELETE_HEAD1,
        payload: id
      });

      dispatch(setAlert("The Topic has been removed", "success"));
    } catch (err) {
      console.log(err);
      dispatch({
        type: HEAD1_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });
    }
  }
};
